import type { Fleet } from "../fleet";
import type { EntitiesData, EntityData } from "../entities";
import type { Defense, Ship } from "../types";

export function getEntities(fleet: Fleet): EntitiesData {
    let result: EntitiesData = {}

    for (let type in fleet.ships) {
        if (fleet.ships[type] != null) {
            result[type] = shipNoNulls(fleet.ships[type])
        }
    }

    if (!fleet.isDefender) {
        return result
    }


    for (let type in fleet.defenses) {
        if (fleet.defenses[type] != null) {
            result[type] = defenseNoNulls(fleet.defenses[type])
        }
    }

    return result
}

function shipNoNulls(ship: Ship): Ship & EntityData {
    return {
        amount: ship.amount || 0,
        weapon: ship.weapon,
        shield: ship.shield,
        armor: ship.armor,
        cargo: ship.cargo,
        speed: ship.speed,
        fuel: ship.fuel
    }
}

function defenseNoNulls(def: Defense): Defense & EntityData {
    return {
        amount: def.amount || 0,
        weapon: def.weapon,
        shield: def.shield,
        armor: def.armor
    }
}

export {
    shipNoNulls
}